const avatars = [
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/077fb33c-1a60-47d0-87c4-5986544c992d.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/0bcf4ffc-79a8-4c40-a17c-47a814f6d8cb.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/2ad82bd0-e59a-413f-827f-ab3966027cb6.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/436c88ac-6358-4bef-8d3f-d5b20702311b.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/62424a3e-9cdc-422f-a2c8-5cce272934e2.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/700380e2-0477-4042-80bf-05057da80202.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/78c9033d-9baf-4063-af97-c25d400dab64.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/8e245094-b04b-4cd5-9007-5550269663ab.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/99bb2f1e-277d-4748-b6f8-08c748336edf.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/b9cc03c8-1768-455d-aa07-8de9edfd346d.jpg",
  },
  {
    Key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/d7af2654-a511-4b9d-a652-61352a6794ff.jpg",
  },
  {
    key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/ed80d870-259d-4d4a-b7cf-c00225b1f6ae.jpg",
  },
  {
    key: "avtar-04",
    image:
      "https://images.premikalove.com/avatars/f1b69a01-3182-461b-a184-a73eb136e9a0.jpg",
  },
];

export default avatars;
